import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, ComponentRef, Input, ViewContainerRef, QueryList } from '@angular/core';
import { environment } from 'src/environments/environment.ironside';
import { Template } from '../shared/entities/template';
import { TemplateFieldObj } from '../shared/entities/template-field-Obj';
import { FormFieldConfig } from '../shared/components/dynamic-component-shared/dropdown/form_field_config';
import { Tables } from '../shared/entities/tables';
import { DropdownComponent } from '../shared/components/dynamic-component-shared/dropdown/dropdown.component';
import { TextboxComponent } from '../shared/components/dynamic-component-shared/textbox/textbox.component';

import { DataTableComponent } from '../shared/components/dynamic-component-shared/data-table/data-table.component';
import { CheckboxComponent } from '../shared/components/dynamic-component-shared/checkbox/checkbox.component';
import { TabService } from '../shared/services/tab.service';
import { Observable, catchError, map, of, retry, throwError } from 'rxjs';
import { MultiLangueComponent } from '../shared/components/dynamic-component-shared/multi-langue/multi-langue.component';
import { ImageComponent } from '../shared/components/dynamic-component-shared/image/image.component';
import { DateComponent } from '../shared/components/dynamic-component-shared/date/date.component';
import { SearchableTextfieldComponent } from '../shared/components/dynamic-component-shared/searchable-textfield/searchable-textfield.component';
import { MultiSelectDropdownComponent } from '../shared/components/dynamic-component-shared/multi-select-dropdown/multi-select-dropdown.component';
import { TextboxlistComponent } from '../shared/components/dynamic-component-shared/textboxlist/textboxlist.component';
import { AddressComponent } from '../shared/components/dynamic-component-shared/address/address.component';
import { Language } from '../shared/entities/language';
import { PictoComponent } from '../shared/components/dynamic-component-shared/picto/picto.component';
import { LabelComponent } from '../shared/components/dynamic-component-shared/label/label.component';
import { NestedValueDataTableComponent } from '../shared/components/dynamic-component-shared/nested-value-data-table/nested-value-data-table.component';
import { ButtonFieldComponent } from '../shared/components/button-field/button-field.component';
import { FormattedTextContentComponent } from '../shared/components/dynamic-component-shared/dynamic-text-content/formatted-text-content.component';
import { TextEditorComponent } from '../shared/components/text-editor/text-editor.component';
import { DynamicDocumentFieldInfoType } from '../shared/entities/dynamic-document';
import { E } from '@angular/cdk/keycodes';
import { MultilangueFormattedTextComponent } from '../shared/components/dynamic-component-shared/multilangue-formatted-text/multilangue-formatted-text.component';

@Injectable({
    providedIn: 'root',
})
export class TemplateService {
    baseUrl = `${environment.API_URL}`;
    templateConfig: FormFieldConfig = new FormFieldConfig();
    constructor(private http: HttpClient) { }

    getDefaut(nom: string) {
        return this.http.get<Template>(`${this.baseUrl}/template/defaut/${nom}`);
    }

    edition(template: Template) {
        return this.http.post<Template>(`${this.baseUrl}/template/edition`, template);
    }
    updateTemplate(template: Template) {
        return this.http.post<Template>(`${this.baseUrl}/template/update`, template);
    }

    deleteImage(url: string) {
        return this.http.get<any>(`${this.baseUrl}${url}`);
        //.pipe(retry(3), catchError(this.handleError));
    }

    private handleError(error: any) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }

        return throwError(errorMessage);
    }

    getTemplateByDocumentName(documentName: string) {
        return new Promise((resolve, reject) => {
            this.http
                .get(`${this.baseUrl}/template/${documentName}`)
                .pipe(
                    map((templates) => {
                        resolve(templates);
                    }),
                    catchError((err) => {
                        reject(err);
                        throw err;
                    })
                )
                .subscribe();
        });
    }

    requestApi(req: string) {
        return this.http.get<any[]>(`${this.baseUrl}${req}`);
    }

    getTemplateAndData(idTemplate: string, idVal: string) {
        return this.http.get<Template>(`${this.baseUrl}/template/${idTemplate}/${idVal}`);
    }

    getRedirectedResourceUrl(resourceUrl: string): string {
        const url = new URL(resourceUrl);

        // choose domain based on environment
        const baseDomain = environment.production
            ? environment.domain_prod
            : environment.domain_dev;

        // replace only the path segment (safer than string replace on full URL)
        const newPath = url.pathname.replace(
            'resource-files',
            'admin/resource-files-redirect'
        );

        return `${baseDomain}${newPath}`;
    }

    getFieldConfig(element: any, data: any) {
        // templateConfig = new FormFieldConfig();
        const templateConfig = new FormFieldConfig();
        let uploadUrl = '';
        if (element.formfield === 'selection') {
            let label = element.label;
            templateConfig.label = label;
            templateConfig.name = element.name;
            templateConfig.value = data ? data[element.name] : null;
            if (data && data['file'] && data['file'].length > 0) {
                const resourceFile = data['file'][0];
                uploadUrl = this.getRedirectedResourceUrl(resourceFile.url);


                const fixedUploadUrl = new URL(uploadUrl);
                fixedUploadUrl.pathname =
                    fixedUploadUrl.pathname.substring(0, fixedUploadUrl.pathname.lastIndexOf('/'))
                    + '/' + resourceFile.resourceFileId;

                templateConfig.uploadUrl = fixedUploadUrl.toString()
            }
            templateConfig.parametreName = element.parametreName;
            templateConfig.simpleMode =
                element.type.toLowerCase() ==
                    DynamicDocumentFieldInfoType.BOOLEAN.toString().toLowerCase()
                    ? true
                    : element.simpleMode;
            templateConfig.isMultiLangue = element.multiLangue;
            templateConfig.entiteClassSelection = element.entiteClassSelection;
            templateConfig.entity = element.entity;
            templateConfig.displayedColumns = element.displayedColumns;
            templateConfig.isDynamic = element.isDynamic;
            // templateConfig.simpleMode = element.isSimpleMode;
            templateConfig.parameterLinkName = element.parameterLinkName;
            templateConfig.parametreName = element.parametreName;
            templateConfig.typeName = element.typeName;
            templateConfig.labelLocal = element.labelLocal;
            templateConfig.isavalidationField = element.isavalidationField;
            if (element.isavalidationField) {
                templateConfig.validationFields.push(element.validationField);
            }
            return templateConfig;
        } else if (element.formfield === 'textbox') {
            templateConfig.label = element.label;
            templateConfig.type = element.type;
            templateConfig.isModifiable = element.isModifiable;
            templateConfig.isVisible = element.isVisible;
            templateConfig.name = element.name;
            templateConfig.value = data ? data[element.name] : null;

            return templateConfig;
        } else if (element.formfield === 'formattedtextbox') {
            templateConfig.label = element.label;
            templateConfig.type = element.type;
            templateConfig.isModifiable = element.isModifiable;
            templateConfig.isVisible = element.isVisible;
            templateConfig.name = element.name;
            templateConfig.value = data ? data[element.name] : null;

            return templateConfig;
        } else if (element.formfield?.trim() === 'multilangueformattedtextbox') {
            templateConfig.label = element.label;
            templateConfig.type = element.type;
            templateConfig.isModifiable = element.isModifiable;
            templateConfig.isVisible = element.isVisible;
            templateConfig.name = element.name;
            templateConfig.value = data ? data[element.name] : null;
            templateConfig.multilangueFields = element.locales;
            //templateConfig.typeName = element.typeName;

            return templateConfig;
        } else if (element.formfield === 'label') {
            templateConfig.label = element.label;
            templateConfig.name = element.name;
            templateConfig.value = data ? data[element.name] : null;
            templateConfig.parametreName = element.parametreName;
            templateConfig.simpleMode = element.simpleMode;
            templateConfig.isMultiLangue = element.multiLangue;
            templateConfig.entiteClassSelection = element.entiteClassSelection;
            templateConfig.entity = element.entity;
            templateConfig.typeName = element.typeName;
            templateConfig.labelLocal = element.labelLocal;
            templateConfig.isavalidationField = element.isavalidationField;
            if (element.isavalidationField) {
                templateConfig.validationFields.push(element.validationField);
            }

            return templateConfig;
        } else if (element.formfield === 'textboxlist') {
            templateConfig.label = element.label;
            templateConfig.value = data ? data[element.name] : null;
            templateConfig.type = element.type;
            templateConfig.displayProperty = element.displayProperty;
            templateConfig.name = element.name;

            return templateConfig;
        } else if (element.formfield === 'table') {
            let label = element.label;
            templateConfig.label = label;
            templateConfig.name = element.name;

            templateConfig.idList = Array.isArray(data?.[element?.name])
                ? [...data[element.name]]
                : (null as any);
            templateConfig.entiteList = Array.isArray(data?.[element?.name])
                ? [...data[element.name]]
                : (null as any);
            if (data && data?.[element.name]?.documentId) {
                // Cas avec les classes backend DocumentLink
                templateConfig.idList = [data[element.name].documentId];
                templateConfig.entiteList = [data[element.name].documentId];
            }
            templateConfig.displayedColumns = element.displayedColumns;
            templateConfig.isDynamic = element.isDynamic;
            templateConfig.documentLinkName = element.documentLinkName;
            templateConfig.type = element.type;
            templateConfig.referenceField = element.referenceField;
            templateConfig.linkedEntite = element.linkedEntite;
            templateConfig.entiteRelationProperte = element.entiteRelationProperte;
            templateConfig.visibilityCheckProperte = element.visibilityCheckProperte;
            templateConfig.visibilityCheckValue = element.visibilityCheckValue;
            if (element.filter) templateConfig.filter = this.getFilters(element.filter[0]);

            return templateConfig;
        } else if (element.formfield === 'innertable') {
            //element.innerpropertyname = 'pictos';
            //element.name = 'pictoCatalogue';
            let label = element.label;
            templateConfig.label = label;
            templateConfig.name = element.name;
            templateConfig.value = data ? data[element.name] : null;
            templateConfig.innerPropertyName = element.innerPropertyName;
            templateConfig.entiteList = data
                ? data[element.name]?.[element.innerPropertyName]
                : null;
            templateConfig.displayedColumns = element.displayedColumns;
            templateConfig.linkedEntite = element.linkedEntite;
            templateConfig.entiteRelationProperte = element.entiteRelationProperte;
            templateConfig.visibilityCheckProperte = element.visibilityCheckProperte;
            templateConfig.visibilityCheckValue = element.visibilityCheckValue;
            if (element.filter) templateConfig.filter = this.getFilters(element.filter[0]);

            return templateConfig;
        } else if (element.formfield === 'checkbox') {
            let label = element.label;
            templateConfig.label = label;
            templateConfig.name = element.name;
            templateConfig.checkboxOptions = data ? data[element.name] : null;
            templateConfig.checkBoxEntite = element.checkBoxEntite;
            templateConfig.checkBoxLabelTitre = element.checkBoxLabelTitre;
            templateConfig.checkBoxValueTitre = element.checkBoxValueTitre;

            return templateConfig;
        } else if (element.formfield === 'multilanguetextbox') {
            templateConfig.label = element.label;
            templateConfig.name = element.name;
            templateConfig.multilangueFields = element.locales;
            templateConfig.isModifiable = element.isModifiable;
            templateConfig.isVisible = element.isVisible;
            templateConfig.value = data
                ? data[element.name]
                : element.value
                    ? element.value
                    : null;

            return templateConfig;
        } else if (element.formfield === 'image') {
            templateConfig.label = element.label;
            templateConfig.name = element.name;
            templateConfig.uploadPath = element.uploadPath;
            templateConfig.uploadUrl = element.uploadUrl;
            templateConfig.singleImageMode = element.singleImageMode;
            templateConfig.type = element.type;
            if (!element.singleImageMode) {
                templateConfig.images = data ? data[element.name] : null; //images
            } else {
                templateConfig.value = data ? data[element.name] : null; //image
            }
            if (
                templateConfig.value === undefined ||
                templateConfig.value === null ||
                (typeof templateConfig.value === 'object' &&
                    Object.keys(templateConfig.value).length === 0)
            ) {
                templateConfig.value = data;
            }
            return templateConfig;
        } else if (element.formfield === 'picto') {
            templateConfig.label = element.label;
            templateConfig.value = data ? data[element.name] : null;
            templateConfig.type = element.type;
            templateConfig.name = element.name;

            return templateConfig;
        } else if (element.formfield === 'datefield') {
            templateConfig.label = element.label;
            templateConfig.name = element.name;
            templateConfig.isModifiable = element.isModifiable;
            templateConfig.isVisible = element.isVisible;
            templateConfig.value = data ? data[element.name] : null;

            return templateConfig;
        } else if (element.formfield === 'searchabletextbox') {
            templateConfig.label = element.label;
            templateConfig.name = element.name;
            templateConfig.value = data ? data[element.name] : null;
            templateConfig.linkedEntite = element.linkedEntite;
            templateConfig.displayMode = element.displayMode;
            templateConfig.entiteRelationProperte = element.entiteRelationProperte;
            templateConfig.searchableFields = element.searchableFields;
            return templateConfig;
        } else if (element.formfield === 'addressfield') {
            templateConfig.label = element.label;
            templateConfig.name = element.name;
            templateConfig.value = data ? data[element.name] : null;
            templateConfig.searchableFields = element.searchableFields;
            return templateConfig;
        } else if (element.formfield === 'multiselectiondropdown') {
            let label = element.label;
            templateConfig.label = label;
            templateConfig.name = element.name;
            templateConfig.value = data ? data[element.name] : null;
            templateConfig.displayedColumns = element.displayedColumns;
            templateConfig.isDynamic = element.isDynamic;
            templateConfig.parameterLinkName = element.parameterLinkName;
            templateConfig.linkedEntite = element.linkedEntite;
            templateConfig.entiteRelationProperte = element.entiteRelationProperte;
            templateConfig.parametreName = element.parametreName;

            return templateConfig;
        } else if (element.formfield === 'actionbutton') {
            let label = element.label;
            templateConfig.label = label;
            templateConfig.name = element.name;
            templateConfig.clickMethod = element.clickMethod;

            return templateConfig;
        } else {
            return null;
        }
    }


    /***
     * @param
     */
    public async loadFormFields(
        vcf: ViewContainerRef,
        config: any,
        filedType: string,
        languages: Language[]
    ) {
        let component: any;
        switch (filedType) {

            case 'selection':
                component = DropdownComponent;
                break;
            case 'textbox':
                component = TextboxComponent;
                break;
            case 'formattedtextbox':
                component = TextEditorComponent;
                break;
            case 'multilangueformattedtextbox':
                component = MultilangueFormattedTextComponent;
                break;
            case 'label':
                component = LabelComponent;
                break;
            case 'table':
                component = DataTableComponent;
                break;
            case 'innertable':
                component = NestedValueDataTableComponent;
                break;
            case 'checkbox':
                component = CheckboxComponent;
                break;
            case 'multilanguetextbox':
                component = MultiLangueComponent;
                break;
            case 'image':
                component = ImageComponent;
                break;
            case 'picto':
                component = PictoComponent;
                break;
            case 'datefield':
                component = DateComponent;
                break;
            case 'searchabletextbox':
                component = SearchableTextfieldComponent;
                break;
            case 'multiselectiondropdown':
                component = MultiSelectDropdownComponent;
                break;
            case 'textboxlist':
                component = TextboxlistComponent;
                break;
            case 'addressfield':
                component = AddressComponent;
                break;
            case 'actionbutton':
                component = ButtonFieldComponent;
                break;
        }

        if (!component) {
            return;
        }

        vcf.clear();

        let componentInstance: ComponentRef<typeof component> = vcf.createComponent(
            component
        );
        componentInstance.setInput('config', config);

        if (filedType === 'multilanguetextbox' || filedType === 'multilangueformattedtextbox') {
            componentInstance.setInput('languages', languages);
        }

        if (filedType === 'table' || filedType === 'innertable' || filedType === 'image') {
            componentInstance.setInput(
                'locales',
                languages
                    .filter((language) => language.selected === true)
                    .map((language) => language.key)
            );
        }

        return componentInstance;
    }

    public processEnregister(
        childComponents: QueryList<any>,
        tab: any,
        isDynamic: boolean = false,
        isSkipSave: boolean = false,
        data?: any,
        currentTemplate?: any
    ): Observable<any> {
        let obj: any = {};
        let entite = tab.entite;
        childComponents.forEach((childComponent) => {
            if (!childComponent.viewRefrence) return;
            const componentInstance = childComponent.viewRefrence.instance;
            const componentType = componentInstance.constructor;
            switch (componentType) {
                case TextboxComponent:
                    obj[childComponent.viewRefrence.instance.config.name] =
                        childComponent.viewRefrence.instance.value;
                    break;
                case TextEditorComponent:
                    obj[childComponent.viewRefrence.instance.config.name] =
                        childComponent.viewRefrence.instance.htmlContent;
                    break;
                case TextboxlistComponent:
                    obj[childComponent.viewRefrence.instance.config.name] =
                        childComponent.viewRefrence.instance.value;
                    break;
                case DropdownComponent:
                    obj[childComponent.viewRefrence.instance.config.name] =
                        childComponent.viewRefrence.instance.config.value;

                    if (
                        childComponent.viewRefrence.instance.config.isDynamic &&
                        !childComponent.viewRefrence.instance.config.simpleMode
                    ) {
                        obj[childComponent.viewRefrence.instance.config.name] = childComponent
                            .viewRefrence.instance.config.value
                            ? childComponent.viewRefrence.instance.config.value.id
                                ? [childComponent.viewRefrence.instance.config.value.id]
                                : []
                            : [];
                    }
                    break;
                case CheckboxComponent:
                    obj[childComponent.viewRefrence.instance.config.name] =
                        childComponent.viewRefrence.instance.checkboxOptions;
                    break;
                case DataTableComponent:
                    // the default value is the id of the linked entite
                    if (
                        childComponent.viewRefrence.instance.config.isDynamic ||
                        childComponent.viewRefrence.instance.config.entiteRelationProperte === 'id'
                    ) {
                        obj[childComponent.viewRefrence.instance.config.name] =
                            childComponent.viewRefrence.instance.config.idList;
                    } else {
                        obj[childComponent.viewRefrence.instance.config.name] =
                            childComponent.viewRefrence.instance.config.entiteList;
                    }
                    break;
                case NestedValueDataTableComponent:
                    // the default value is the id of the linked entite
                    if (
                        childComponent?.viewRefrence?.instance?.config.entiteRelationProperte ===
                        'id'
                    ) {
                        obj[childComponent.viewRefrence.instance.config.name] =
                            childComponent.viewRefrence.instance.config.idList;
                    } else {
                        obj[childComponent.viewRefrence.instance.config.name] =
                            childComponent.viewRefrence.instance.config.value;
                        if (
                            obj[childComponent.viewRefrence.instance.config.name] &&
                            obj[childComponent.viewRefrence.instance.config.name][
                            childComponent.viewRefrence.instance.config.innerPropertyName
                            ]
                        ) {
                            obj[childComponent.viewRefrence.instance.config.name][
                                childComponent.viewRefrence.instance.config.innerPropertyName
                            ] = childComponent.viewRefrence.instance.config.entiteList;
                        }
                        // obj[childComponent.viewRefrence.instance.config.name][
                        //   childComponent.viewRefrence.instance.config.innerPropertyName
                        // ] = childComponent.viewRefrence.instance.config.entiteList;
                    }
                    break;
                case MultilangueFormattedTextComponent:
                case MultiLangueComponent:
                    obj[childComponent.viewRefrence.instance.config.name] = childComponent
                        .viewRefrence.instance.multilangueMap
                        ? childComponent.viewRefrence.instance.multilangueMap
                        : childComponent.viewRefrence.instance.value;
                    break;
                case ImageComponent:
                    if (childComponent.viewRefrence.instance.config.singleImageMode) {
                        obj[childComponent.viewRefrence.instance.config.name] =
                            childComponent.viewRefrence.instance.image;
                    } else {
                        obj[childComponent.viewRefrence.instance.config.name] =
                            childComponent.viewRefrence.instance.imagesMap;
                    }
                    break;
                case PictoComponent:
                    obj[childComponent.viewRefrence.instance.config.name] =
                        childComponent.viewRefrence.instance.config.value;
                    break;
                case DateComponent:
                    let date = childComponent.viewRefrence.instance.formatDate(
                        childComponent.viewRefrence.instance.selectedDateControl.value
                    );
                    obj[childComponent.viewRefrence.instance.config.name] = date;
                    break;
                case SearchableTextfieldComponent:
                    if (childComponent.viewRefrence.instance.searchArticlesCtrl.value) {
                        obj[childComponent.viewRefrence.instance.config.name] =
                            childComponent.viewRefrence.instance.config.value;
                    } else {
                        obj[childComponent.viewRefrence.instance.config.name] = null;
                    }

                    break;
                case LabelComponent:
                    obj[childComponent.viewRefrence.instance.config.name] =
                        childComponent.viewRefrence.instance.config.value;
                    break;
                case MultiSelectDropdownComponent:
                    obj[childComponent.viewRefrence.instance.config.name] =
                        childComponent.viewRefrence.instance.config.value;
                    if (childComponent.viewRefrence.instance.config.isDynamic) {
                        obj[childComponent.viewRefrence.instance.config.name] = childComponent
                            .viewRefrence.instance.config.value
                            ? childComponent.viewRefrence.instance.config.value
                                .map((el: any) => el.id)
                                .filter((item: any) => item)
                            : [];
                    }
                    break;
                case AddressComponent:
                    obj[childComponent.viewRefrence.instance.config.name] =
                        childComponent.viewRefrence.instance.getAddressLigne();
            }
        });

        // Kiểm tra và thêm 'hit' nếu cần
        if (!obj.hasOwnProperty('hit') || obj['hit'] === null || obj['hit'] === undefined) {
            obj['hit'] = 1;
        }

        let entiteUrl = isDynamic
            ? `${this.baseUrl}/dynamic-documents/${tab.entite}`
            : this.getEntiteurl(entite);
        if (tab.id) {
            obj.id = tab.id;
        }
        let cloneTemplateDate: any = {};
        if (currentTemplate && currentTemplate?.parameters?.length) {
            currentTemplate.parameters.forEach((item: any) => {
                if (item?.name && item?.formfield === 'datefield') {
                    cloneTemplateDate[item.name] = item.name;
                }
            });
        }

        const saveObj = { ...data, ...obj };

        Object.keys(saveObj).forEach((key) => {
            if (cloneTemplateDate[key]) {
                saveObj[key] = this.formatDate(saveObj[key]);
            }
        });


        return isSkipSave ? of(saveObj) : this.http.post<any>(entiteUrl, saveObj);
    }

    formatDate(dateString: any): any {
        return dateString
            ? new Date(dateString).toISOString().substring(0, 19)
            : new Date().toISOString().substring(0, 19);
    }

    getEntiteurl(entite: string) {
        entite = entite.toLowerCase();
        return `${this.baseUrl}/${entite}/add`;
    }

    getDropDownValues(url: string, frontOfficeCall: boolean = false) {
        const options: any = {};
        if (frontOfficeCall) {
            options.headers = new HttpHeaders().append('Frontend-Request', 'true');
        }
        return this.http.get<any>(url, options);
    }

    getFilters(filterName: string) {
        if (!filterName) {
            return null;
        }
        filterName = filterName.toLowerCase();
        switch (filterName) {
            case 'article':
                return [
                    {
                        champ: 'estArticle',
                        conditions: [
                            {
                                id: 0,
                                type: 'UNKNOWN',
                                condition: 'EQUALS',
                                valeur: true,
                            },
                        ],
                        default: true,
                    },
                ];
            case 'produit':
                return [
                    {
                        champ: 'estProduit',
                        conditions: [
                            {
                                id: 0,
                                type: 'UNKNOWN',
                                condition: 'EQUALS',
                                valeur: true,
                            },
                        ],
                        default: true,
                    },
                ];
        }

        return null;
    }
}
